/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import { setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import sogoYusoKaigiService from "../../../service/budget/sogoYusoKaigi/sogoYusoKaigiService"
import { TGekkanSyukeiPutReq } from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"

/**
 * 月間集計管理テキスト編集モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const UpdateGekkanSyukeiTextModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    id?: number
    年月: string
    text: string
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  //#region [state]

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [予算実績タイトル, set予算実績タイトル] = useState<string>(props.text)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    setAlertSource(undefined)
    try {
      const service = new sogoYusoKaigiService()
      const cond: TGekkanSyukeiPutReq = {
        月次集計管理ID: props.id,
        予算実績タイトル: 予算実績タイトル,
      }
      let res = await service.putSyukeiTitle(cond)
      if (res.data) {
        props.setIsShow(false)
        props.setIsEdited(true)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (props.isShow) {
      set予算実績タイトル(props.text)
    }
  }, [props.isShow])
  //#endregion
  return (
    <form
      onSubmit={(e) => {
        e.stopPropagation()
        e.preventDefault()
        beforeSubmit()
        return false
      }}>
      <ModalOuter
        isShow={props.isShow}
        title={props.title ?? "予算実績タイトル更新"}
        setIsShow={props.setIsShow}
        size={"sm"}
        footer={
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            更新
          </Button>
        }>
        <Container fluid className="label-form">
          {/* アラート表示 */}
          <Row>
            <Col>
              <LocalAlertComponent alertSource={AlertSource} />
            </Col>
          </Row>
          <form>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-8rem">予算実績タイトル</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "12rem" }}
                            id="予算実績タイトル"
                            name="予算実績タイトル"
                            value={予算実績タイトル}
                            setValue={(e) => {
                              set予算実績タイトル(e)
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </form>
        </Container>
        <ConfirmModal
          isShow={isConfirmModalShow}
          hideHandler={setIsConfirmModalShow}
          submitHandler={submit}>
          入力された内容で更新しますか？
        </ConfirmModal>
      </ModalOuter>
    </form>
  )
}

export default UpdateGekkanSyukeiTextModal
